<template>
  <div class="stats-section">
    <div class="stats-section__middle-wrap">
      <div class="stats-section__col">
        <div class="stats-section__counter">5m+</div>
        <div class="stats-section__text">Orders delivered directly to customers</div>
      </div>
      <div class="stats-section__col">
        <div class="stats-section__counter">100%</div>
        <div class="stats-section__text">Guaranteed quality and delivery of orders</div>
      </div>
      <div class="stats-section__col">
        <div class="stats-section__counter">300+</div>
        <div class="stats-section__text">Very happy clients</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'StatsSection',
  components: {

  },
  props: {

  },
  data () {
    return {}
  },
  computed: {

  },
  methods: {
  }
}
</script>

<style lang="sass" scoped>
@import '~styles/shared'

.stats-section
  background: #43d394
  color: #fff
  font: 23px/30px Nunito, Gilroy, sans-serif
  padding: 37px 0 65px

  @include tablet
    padding-bottom: 50px

  @include desktop
    padding-top: 101px
    padding-bottom: 106px

.stats-section__middle-wrap
  @include desktop
    display: flex
    max-width: 1200px
    margin: 0 auto

.stats-section__col
  text-align: center
  padding: 23px 20px

  @include tablet
    padding: 27px 20px 26px

  @include desktop
    width: 33.33%
    padding-left: 40px
    padding-right: 40px

.stats-section__counter
  font-size: 50px
  line-height: normal

  @include tablet
    font-size: 75px
    line-height: 82px

.stats-section__text
  margin-top: 8px

  @include desktop
    margin-top: 16px
    line-height: 1.6
</style>



// WEBPACK FOOTER //
// src/StatsSection.vue